import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../styles/variables";
import Wrapper from "../Wrappers/Wrapper";
import MitarbeiterSchlichtItem from "./MitarbeiterSchlichtItem";

const GridDiv = styled.div`
  margin-top: 40px;

  @media screen AND (min-width: 700px) {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: center;

    > article {
      margin-right: 20px;
      width: calc((100% - 40px) / 2);
    }

    > article:last-of-type {
      margin-right: 0;
    }
  }

  @media screen AND (min-width: ${breakpoints.desktop}px) {
    > article {
      width: calc((100% - 60px) / 2);
      margin-right: 30px;
    }
  }
`;

const MitarbeiterSchlicht = ({ color, content, siteId }) => (
  <Wrapper>
    <GridDiv>
      {content.map((item, index) => (
        <MitarbeiterSchlichtItem
          color={color}
          content={item}
          key={index}
          siteId={siteId}
        />
      ))}
    </GridDiv>
  </Wrapper>
);

export default MitarbeiterSchlicht;
